import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketContacts = ({ dispatch, searchParam, resetContactsListCallback, typeOfContact }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();
  


  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const checkShouldCallDispatch = (contact, typeOfContact) => {
        const shouldUpdateContact = !contact.isGroup && !contact.isBlocked && !contact.isInactive && typeOfContact === "0";
        const shouldUpdateGroup = contact.isGroup && typeOfContact === "1";
        const shouldUpdateBlocked = contact.isBlocked && typeOfContact === "3";
        const shouldUpdateInactive = contact.isInactive && typeOfContact === "4";

        const shouldCallDispatch = shouldUpdateContact || shouldUpdateGroup || shouldUpdateBlocked || shouldUpdateInactive;
        return shouldCallDispatch;
      };

      const handleContact = async (data) => {
        if ((["update", "create"].includes(data.action)) && checkShouldCallDispatch(data.contact, typeOfContact) && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: "UPDATE_CONTACTS", payload: data.contact, searchParam });
        }
  
        if ((data.action === "delete") && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        }
  
        if ((data.action === "import") && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          resetContactsListCallback();
        }
      }; 
  
      socket.on("contact", handleContact);
  
      return () => {
        socket.off("contact", handleContact);
      };
    }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, resetContactsListCallback, searchParam]);


  
  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketContacts;